import { Finanziamento } from './finanziamento';

export class InterventoFinanziamento{
    id:number;
    importo:number;
    finanziamento:Finanziamento;
    interventoId:number;
    annualita:any[];
}